export const currentUser = ["Silviu"];
